import { CompanyEquipmentData } from "@/features/privateCompanies/types/companyEquipments.type";
import { create } from "zustand";

interface UseWorkflowShowStore {
  init: () => void;

  equipment: CompanyEquipmentData | undefined;
  setEquipment: (equipment: CompanyEquipmentData | undefined) => void;

  currentEquipmentUsage: number | undefined;
  setCurrentEquipmentUsage: (currentEquipmentUsage: number | undefined) => void;
}

export const useWorkflowShowStore = create<UseWorkflowShowStore>((set) => ({
  init: () => set({
    equipment: undefined,
  }),

  equipment: undefined,
  setEquipment: (equipment) => set({
    equipment,
  }),

  currentEquipmentUsage: undefined,
  setCurrentEquipmentUsage: (currentEquipmentUsage) => set({
    currentEquipmentUsage,
  }),
}));
